import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/destinations/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/pipelines/destinations/journeys',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
